import { render, staticRenderFns } from "./novaOrdem.vue?vue&type=template&id=1d15933d"
import script from "./novaOrdem.vue?vue&type=script&lang=js"
export * from "./novaOrdem.vue?vue&type=script&lang=js"
import style0 from "./novaOrdem.vue?vue&type=style&index=0&id=1d15933d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports